import React from 'react';
import Slider from 'react-slick';
import './NewsShorts.css';
import { Link } from 'react-router-dom';
import CustomLink from '../CustomLink/CustomLink.js';

const NewsShorts = ({ news, data }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  };

  // Extract `_id` or `$oid` dynamically
  const getBlogId = (news) => {
    if (news._id && typeof news._id === 'object' && news._id.$oid) {
      return news._id.$oid; // Use `$oid` if it exists
    }
    return news._id; // Fallback to `_id` directly
  };

  return (
    <div className="news-latest-container">
      <div className="news-latest-header-container">
        <h1 className="news-latest-Header">{data.HomeBlogTitle}</h1>
        <CustomLink link={data.HomeBlogLink} linktext={data.HomeBlogText || 'Read More'} />
      </div>

      <Slider {...settings}>
        {news.map((news, index) => (
          <Link
            to={`/${data.HomeBlogLink}/${getBlogId(news)}`}
            key={index}
            className="news-latest-card-link"
          >
            <div className="news-latest-card">
              <img src={news.photo} alt={news.title} className="news-latest-photo" />
              <h3 className="news-latest-title">{news.title}</h3>
              <p className="news-latest-details">{news.details}</p>
            </div>
          </Link>
        ))}
      </Slider>
    </div>
  );
};

export default NewsShorts;
